"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const faCircleInfo_1 = require("@fortawesome/pro-solid-svg-icons/faCircleInfo");
const faCircleCheck_1 = require("@fortawesome/pro-solid-svg-icons/faCircleCheck");
const faTriangleExclamation_1 = require("@fortawesome/pro-solid-svg-icons/faTriangleExclamation");
const faCircleXmark_1 = require("@fortawesome/pro-solid-svg-icons/faCircleXmark");
const Icon = ({ icon, className = "", iconTitle, ...iconProps }) => {
    const [width, height, , , pathData] = icon.icon;
    const hasTitle = typeof iconTitle === "string";
    return ((0, jsx_runtime_1.jsxs)("svg", { className: ["dds-infobox__icon", className].join(" "), viewBox: `0 0 ${width} ${height}`, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": !hasTitle, ...iconProps, children: [hasTitle && (0, jsx_runtime_1.jsx)("title", { children: iconTitle }), (0, jsx_runtime_1.jsx)("path", { fill: "currentColor", d: pathData })] }));
};
function getIconForVariant(variant) {
    switch (variant) {
        case "info":
            return faCircleInfo_1.faCircleInfo;
        case "success":
            return faCircleCheck_1.faCircleCheck;
        case "warning":
            return faTriangleExclamation_1.faTriangleExclamation;
        case "error":
            return faCircleXmark_1.faCircleXmark;
    }
}
const Infobox = ({ variant, title, level, children, className, ...restProps }) => {
    const classNames = [
        "dds-infobox",
        `dds-infobox--${variant}`,
        className || "",
    ].join(" ");
    const TitleComponent = `h${level}`;
    if ("icon" in restProps) {
        const { icon, ...divProps } = restProps;
        return ((0, jsx_runtime_1.jsxs)("div", { className: classNames, ...divProps, children: [icon, (0, jsx_runtime_1.jsxs)("div", { children: [title && ((0, jsx_runtime_1.jsx)(TitleComponent, { className: "dds-infobox__title", children: title })), children] })] }));
    }
    const { iconProps, iconTitle, ...divProps } = restProps;
    return ((0, jsx_runtime_1.jsxs)("div", { className: classNames, ...divProps, children: [(0, jsx_runtime_1.jsx)(Icon, { icon: getIconForVariant(variant), iconTitle: iconTitle, ...iconProps }), (0, jsx_runtime_1.jsxs)("div", { children: [title && ((0, jsx_runtime_1.jsx)(TitleComponent, { className: "dds-infobox__title", children: title })), children] })] }));
};
exports.default = Infobox;
//# sourceMappingURL=Infobox.js.map